/* Progressive enhancement: Shopify forms remain usable without JavaScript. */
(function () {
  'use strict';
  function updateVariant(input) {
    var section = input.closest('.product-section');
    if (!section) return;
    var available = input.dataset.available === 'true';
    var price = section.querySelector('[data-product-price]');
    var stock = section.querySelector('[data-stock-stat]');
    var message = section.querySelector('[data-stock-message]');
    var add = section.querySelector('[data-add-to-cart]');
    if (price) price.textContent = input.dataset.price;
    if (stock) stock.classList.toggle('is-empty', !available);
    if (message) message.textContent = available ? 'En stock' + (input.dataset.hasSize === 'true' ? ' — taille ' + input.dataset.size : '') : 'Épuisé dans cette taille';
    if (add) {
      add.disabled = !available;
      add.textContent = available ? 'Ajouter au panier' : 'Épuisé dans cette taille';
    }
    section.querySelectorAll('[data-color-link]').forEach(function (link) {
      var match = Array.from(link.querySelectorAll('[data-color-variants] [data-size]')).find(function (variant) { return variant.dataset.size === input.dataset.size; });
      if (match) {
        var colorUrl = new URL(link.dataset.productUrl, window.location.origin);
        colorUrl.searchParams.set('variant', match.dataset.variantId);
        link.href = colorUrl.toString();
      }
    });
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-product-variant]:checked').forEach(updateVariant);
  }
  function refreshCart(form) {
    if (!form || form.dataset.submitting === 'true') return;
    if (!form.reportValidity()) return;
    form.requestSubmit(form.querySelector('[data-cart-update]'));
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-product-variant]')) {
      updateVariant(event.target);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', event.target.value);
      window.history.replaceState({}, '', url.toString());
    }
    if (event.target.matches('[data-cart-quantity]')) refreshCart(event.target.closest('form'));
  });
  document.addEventListener('click', function (event) {
    var stepButton = event.target.closest('[data-quantity-step]');
    if (stepButton) {
      var input = stepButton.closest('[data-quantity-control]').querySelector('input');
      if (stepButton.dataset.quantityStep === '1') input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var guideLink = event.target.closest('[data-size-guide]');
    if (guideLink) {
      var guide = document.getElementById(guideLink.hash.slice(1));
      if (guide) { guide.open = true; guide.querySelector('summary').focus(); }
      return;
    }
    var thumbnail = event.target.closest('[data-product-image]');
    if (thumbnail) {
      var section = thumbnail.closest('.product-section');
      var mainImage = section.querySelector('[data-main-image]');
      if (mainImage) {
        event.preventDefault();
        mainImage.removeAttribute('srcset');
        mainImage.src = thumbnail.href;
        mainImage.alt = thumbnail.dataset.imageAlt;
        section.querySelectorAll('[data-product-image]').forEach(function (image) { image.setAttribute('aria-current', image === thumbnail ? 'true' : 'false'); });
      }
    }
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-cart-form]')) return;
    if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    var status = form.querySelector('[data-cart-status]');
    if (status) status.textContent = event.submitter && event.submitter.name === 'checkout' ? 'Ouverture du paiement…' : 'Mise à jour du panier…';
  });
  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-cart-form]').forEach(function (form) {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      var status = form.querySelector('[data-cart-status]');
      if (status) status.textContent = '';
    });
  });
})();
